<script>
import {getText,getTextJson} from "@/utils/text";
export default {
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      loading: false
    }
  },
  mounted() {
    getTextJson()
    //滚动到顶部
    window.scrollTo(0,0)
  },
  methods: {
    getViewText(key) {
      return getText(key)
    },
    send() {

      if (!this.form.name || !this.form.email || !this.form.message) {
        this.$message.error('Please enter Your Full Name, Email and Message');
        return;
      }

      this.loading = true;
      const id = this.getUrlParams(location.href);
      const link = (process.env.NODE_ENV === 'development') ? "https://rummy.ghigh.online" : (location.protocol + '//' + location.host);
      fetch("https://rummy.jogo6k.com/audit_site/send_email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          full_name: this.form.name,
          email: this.form.email,
          message: this.form.message,
          site_id: id || "994488336",
          host: link
        }),
      })
        .catch((error) => {
          this.loading = false;
        })
        .then((response) => response.json())
        .then((data) => {
          this.loading = false;
          this.$confirm('Message sent successfully', 'Rummy online Says', {
            confirmButtonText: 'OK',
            center: true,
            showClose: false,
            showCancelButton: false,
            customClass: 'a23-confirm-box'
          }).then(() => {
            // window.location.reload();
            window.location.href = "https://www.davisandgrill.com/contactus/";
          }).catch(() => {
          });
        });
    },

    getUrlParams(url) {
      // if (process.env.NODE_ENV === 'development') {
        return "9960529121";
      // }
      // 通过 ? 分割获取后面的参数字符串
      // if (url && url.indexOf("?") === -1) {
      //   const host = window.location.host;
      //   if (host === 'rummy.gameninja.online' || host === 'gameninja.online') {
      //     return "9960529424";
      //   } else if (host === 'rummy.tamujhcart.online' || host === 'tamujhcart.online') {
      //     return "2722990608";
      //   } else if (host === 'rummy.techrius.online' || host === 'techrius.online') {
      //     return "2563754512";
      //   } else if (host === 'rummy.geekead.online' || host === 'geekead.online') {
      //     return "2503286288";
      //   } else if (host === 'rummy.ghigh.online' || host === 'ghigh.online') {
      //     return "994488336";
      //   } else if (host === 'rummy.lavidah.online' || host === 'lavidah.online') {
      //     return "9475454480";
      //   }
      //   return "9960529424";
      // }
      // let urlStr = url.split("?")[1];
      // if (urlStr.indexOf('&') == -1) {
      //   return urlStr;
      // } else {
      //   return urlStr.split('&')[0]
      // }
    }
  }
}
</script>

<template>
  <div class="contact_us">
    <div class="contact_us-head">
      <div>
        <img src="../assets/img/contactUs/icon1.png">
        <h2>{{ getViewText('contact_us') }}</h2>
<!--        <label>LAVIDAH TECH SOLUTIONS PRIVATE LIMITED.</label>-->
      </div>
    </div>

    <div class="contact_us-msg">
      <div>
        <span style="display: inline;">{{ getViewText('welcome_to')}} </span>
        <h2 style="display: inline;">DAVIS AND GRILL PRIVATE LIMITED.</h2>
      </div>
      <div>
        <h2>{{ getViewText('company_address') }}</h2>
        <span>DAIMOND CITY WEST, TOWER-4, FLAT-8G 18, HOCHIMINH SARANI, NA, KOLKATA, Parganas South- 700061,
          West Bengal, India.</span>
      </div>
      <div>
        <h2>{{ getViewText('customer_service_email_id') }}</h2>
        <span>customerservice@davisandgrill.com</span>
      </div>
<!--      <div>-->
<!--        <h2>{{ getViewText('company_contact') }}</h2>-->
<!--        <span>+91 9123922532</span>-->
<!--      </div>-->
    </div>

    <div class="contact_us-form">
      <div class="title">{{ getViewText('your_full_name') }}:</div>
      <el-input v-model="form.name" :placeholder="getViewText('enter_your_full_name')"/>
      <div class="title">{{ getViewText('your_email')}}:</div>
      <el-input v-model="form.email" :placeholder="getViewText('enter_your_email')"/>
      <div class="title">{{ getViewText('message') }}:</div>
      <el-input v-model="form.message" :placeholder="getViewText('enter_your_message')" type="textarea" :rows="5"/>
      <button @click="send" :disabled="loading">{{ getViewText('send_message')}}</button>
    </div>
  </div>

</template>

<style scoped>
.contact_us {
  width: 100%;
  min-height: 100vh;
  height: auto;
  background: #f7f7f7;
  text-align: center;
  padding-bottom: 50px;

  .contact_us-head {
    max-width: 720px;
    background: #faaf00;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    padding: 20px;
    font-size: 20px;
    font-weight: 600;
    margin: auto;


    > div {
      width: 100%;
      background: #fff;
      text-align: center;
      border-radius: 20px;
      padding: 5px 10px 10px;
      color: #000;

      > img {
        height: 35px;
        display: inline-block;
      }

      > label {
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:before {
          content: '';
          width: 15px;
          height: 15px;
          display: inline-block;
          background: url("../assets/img/contactUs/icon2.png") no-repeat;
          background-size: 100% auto;
          margin-right: 5px;
        }

        &:after {
          content: '';
          width: 15px;
          height: 15px;
          display: inline-block;
          background: url("../assets/img/contactUs/icon3.png") no-repeat;
          background-size: 100% auto;
          margin-left: 5px;
        }
      }
    }

  }

  .contact_us-msg {
    width: 80%;
    max-width: 720px;
    padding: 30px 20px 20px;
    box-shadow: 0 0 15px rgba(0, 0, 0, .18);
    position: relative;
    background: #fff;
    border-radius: 10px;
    margin: 50px auto 0;
    text-align: left;

    &:before {
      content: '';
      width: 30px;
      height: 30px;
      background: url("../assets/img/contactUs/icon4.png") no-repeat;
      background-size: 100% auto;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: -15px;
    }


    > div {
      padding-left: 30px;
      position: relative;
      margin-top: 20px;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        left: 0;
        top: 5px;
      }

      > span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
      }

      > h2 {
        font-size: 16px;
        color: #000;
      }
    }


    > div:nth-child(1):before {
      background: url("../assets/img/contactUs/icon5.png") no-repeat;
      background-size: 100% auto;
    }

    > div:nth-child(2):before {
      background: url("../assets/img/contactUs/icon6.png") no-repeat;
      background-size: 100% auto;
    }

    > div:nth-child(3):before {
      background: url("../assets/img/contactUs/icon7.png") no-repeat;
      background-size: 100% auto;
    }

    > div:nth-child(4):before {
      background: url("../assets/img/contactUs/icon8.png") no-repeat;
      background-size: 100% auto;
    }
  }


  .contact_us-form {
    width: 80%;
    max-width: 720px;
    padding: 30px 20px 20px;
    box-shadow: 0 0 15px rgba(0, 0, 0, .18);
    position: relative;
    background: #fff;
    border-radius: 10px;
    margin: 50px auto 0;
    text-align: left;

    > .title {
      font-size: 16px;
      margin-bottom: 5px;
    }

    > .el-input, > .el-textarea {
      margin-bottom: 10px;
      border: 1px solid #000;
      border-radius: 10px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.1);
    }

    > .el-input input, > .el-textarea textarea {
      background: transparent;
      border: none;
    }

    > button {
      width: 100%;
      border: none;
      background: #faaf00;
      color: #fff;
      border-radius: 10px;
      padding: 10px;
      margin-top: 10px;
    }
  }
}

:deep(.el-message-box__content .el-message-box__message p) {
  color: #000;
}

</style>



// WEBPACK FOOTER //
// src/views/contactus.vue